import { createReducer } from '../../util';
import * as actions from '../actions/creditUsage';
import { StatusState } from './common';

const initialStatusState : StatusState = {
    error: false,
    errorMessage: '',
    pending: false,
};

const initialState = {
    data: [],
    aiData: [],
    systemData: [],

    list: {
        ...initialStatusState,
    },
    download: {
        ...initialStatusState,
    },
    aiList: {
        ...initialStatusState,
    },
    aiDownload: {
        ...initialStatusState,
    },
    systemList: {
        ...initialStatusState,
    },
    systemDownload: {
        ...initialStatusState,
    }
};

export default createReducer(initialState, {
    [actions.CREDIT_USAGE_REPORT_LANDING_PENDING]: (state) => ({
        ...state,
        list: {
            pending: true,
        },
        data: []
    }),
    [actions.CREDIT_USAGE_REPORT_LANDING_FULFILLED]: (state, results) => ({
        ...state,
        list: {
            ...initialStatusState,
        },
        data: results,
    }),
    [actions.CREDIT_USAGE_REPORT_LANDING_REJECTED]: (state, errorMessage) => ({
        ...state,
        list: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CREDIT_USAGE_REPORT_DOWNLOAD_PENDING]: (state) => ({
        ...state,
        download: {
            pending: true,
        },
    }),
    [actions.CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED]: (state) => ({
        ...state,
        download: {
            ...initialStatusState,
        },
    }),
    [actions.CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED]: (state, errorMessage) => ({
        ...state,
        download: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.CREDIT_USAGE_REPORT_RESET]: (state) => ({
        ...state,
        data: []
    }),

    [actions.AI_CREDIT_USAGE_REPORT_LANDING_PENDING]: (state) => ({
        ...state,
        aiList: {
            pending: true,
        },
        aiData: []
    }),
    [actions.AI_CREDIT_USAGE_REPORT_LANDING_FULFILLED]: (state, results) => ({
        ...state,
        aiList: {
            ...initialStatusState,
        },
        aiData: results,
    }),
    [actions.AI_CREDIT_USAGE_REPORT_LANDING_REJECTED]: (state, errorMessage) => ({
        ...state,
        aiList: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.AI_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING]: (state) => ({
        ...state,
        aiDownload: {
            pending: true,
        },
    }),
    [actions.AI_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED]: (state) => ({
        ...state,
        aiDownload: {
            ...initialStatusState,
        },
    }),
    [actions.AI_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED]: (state, errorMessage) => ({
        ...state,
        aiDownload: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.AI_CREDIT_USAGE_REPORT_RESET]: (state) => ({
        ...state,
        aiData: []
    }),

    [actions.SYSTEM_CREDIT_USAGE_REPORT_LANDING_PENDING]: (state) => ({
        ...state,
        systemList: {
            pending: true,
        },
        systemData: []
    }),
    [actions.SYSTEM_CREDIT_USAGE_REPORT_LANDING_FULFILLED]: (state, results) => ({
        ...state,
        systemList: {
            ...initialStatusState,
        },
        systemData: results,
    }),
    [actions.SYSTEM_CREDIT_USAGE_REPORT_LANDING_REJECTED]: (state, errorMessage) => ({
        ...state,
        systemList: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_PENDING]: (state) => ({
        ...state,
        systemDownload: {
            pending: true,
        },
    }),
    [actions.SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_FULFILLED]: (state) => ({
        ...state,
        systemDownload: {
            ...initialStatusState,
        },
    }),
    [actions.SYSTEM_CREDIT_USAGE_REPORT_DOWNLOAD_REJECTED]: (state, errorMessage) => ({
        ...state,
        systemDownload: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.SYSTEM_CREDIT_USAGE_REPORT_RESET]: (state) => ({
        ...state,
        systemData: []
    }),
});
